import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  Box,
  useTheme,
  TextField,
  Switch,
  Dialog,
  styled,
  DialogTitle,
  DialogContent,
  MenuItem,
  Autocomplete,
} from '@mui/material';
import CustomInput from '../../../../../../components/shared/CustomInput';
import BackButton from '../../../../../../components/shared/BackButton';
import dayjs from 'dayjs';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { useEffect, useState } from 'react';
import CustomDialog from '../../../../../../components/shared/CustomDialog';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import CustomCard from '../../../../../../components/shared/CustomCard';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import useGetDifferent2Arrays from '../../../../../../hooks/useGetDifferent2Arrays';
import CustomButton from '../../../../../../components/shared/CustomButton';
import CustomTextFormatingInput from '../../../../../../components/shared/CustomTextFormatingInput/CustomTextFormatingInput';
import CustomSelect from '../../../../../../components/shared/CustomSelect';
import {
  deleteCategoryProduct,
  updateCategoryProduct,
} from '../../../../../../api/products';

const CategoryProductEditMobile = (props) => {
  const {
    handleBackButton,
    subsidiaryDatas,
    categoryEditInputDatas,
    setCategoryEditInputDatas,
    theme,
    AntSwitch,
    today,
    handleDelete,
    handleEditCategory,
    handleAddImage,
    handleDeleteImage,
    handlePreviewImage,
    isSubmitAvailable,
    // *---------
    typeCategoryOptions,
  } = props;
  return (
    <Grid container columns={12} spacing={2}>
      {/* Edit Category */}
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BackButton handleClick={handleBackButton} />
        <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>
          Edit Category
        </Typography>
      </Grid>
      {/* SUBSIDIARY */}
      <Grid item xs={12}>
        <Autocomplete
          sx={{ bgcolor: '#FAFAFA', borderRadius: '8px', fontSize: '12px' }}
          value={categoryEditInputDatas.subsidiary}
          placeholder="Subsidiary"
          options={subsidiaryDatas}
          getOptionLabel={(option) => option.name}
          onChange={(event, newValue) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              subsidiaryId: parseInt(newValue.id),
              subsidiary: newValue,
            });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Subsidiary" />
          )}
        />
      </Grid>
      {/* NAME */}
      <Grid item xs={12}>
        <CustomInput
          value={categoryEditInputDatas.name}
          onChange={(e) => {
            if (e.target.value.length <= 30) {
              setCategoryEditInputDatas({
                ...categoryEditInputDatas,
                name: e.target.value,
              });
            }
          }}
          placeholder="Name*"
          sx={{
            bgcolor: '#FAFAFA',
            borderRadius: '8px',
            width: '100%',
            fontSize: '12px',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 5 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryEditInputDatas.name.length}/30
          </Typography>
        </Box>
      </Grid>
      {/* Type */}
      {/* <Grid item xs={12}>
        <Autocomplete
          options={typeCategoryOptions}
          getOptionLabel={(option) => option.nmOpsi}
          inputValue={categoryEditInputDatas.typeInput}
          onInputChange={(_, newValue) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              typeInput: newValue,
            });
          }}
          value={categoryEditInputDatas.type}
          onChange={(_, newValue) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              type: newValue,
              typeId: newValue.iDopsi,
              typeName: newValue.nmOpsi,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                bgcolor: '#FAFAFA',
                borderRadius: '8px',
                width: '100%',
                '.MuiOutlinedInput-input': {
                  fontSize: '12px',
                  padding: '12px',
                },
              }}
              placeholder="Select Type"
            />
          )}
          loading={categoryEditInputDatas.typeLoading}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryEditInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid> */}
      {/* PHOTO */}
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            pb: `${categoryEditInputDatas.photo.length === 0 ? '16px' : '9px'}`,
            alignItems: 'center',
          }}
        >
          <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
            Photo
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '500',
              color: '#9E9D9D',
            }}
          >
            ( max size : 2MB )
          </Typography>
          {categoryEditInputDatas.isMaxSizePhoto && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ErrorOutlineIcon
                sx={{
                  fontSize: '8px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                  mr: '4px',
                }}
              />
              <Typography
                sx={{
                  fontSize: '8px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                }}
              >
                The photo can't be more than 2MB
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {categoryEditInputDatas.photoUrls.length === 0 && (
              <Box
                sx={{
                  height: '54px',
                  width: '54px',
                  aspectRatio: '1/1',
                  borderRadius: '8px',
                  bgcolor: '#F5F5F5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderStyle: 'dashed',
                  borderColor: '#9E9D9D',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <ImageOutlinedIcon
                  sx={{ color: '#9E9D9D', fontSize: '28px' }}
                />
              </Box>
            )}
            {categoryEditInputDatas.photoUrls.map((input, index) => (
              <Box
                sx={{
                  position: 'relative',
                  overflow: 'visible',
                  padding: '7px',
                }}
                key={index}
              >
                <CancelIcon
                  sx={{
                    position: 'absolute',
                    fontSize: '20px',
                    top: 1,
                    right: 1,
                    zIndex: +1,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDeleteImage(input)}
                />
                <Box
                  component="img"
                  src={process.env.REACT_APP_API_IMAGE_BASE_URL + '/' + input}
                  sx={{
                    height: '54px',
                    width: '54px',
                    aspectRatio: '1/1',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => handlePreviewImage(input)}
                />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              mb: '7px',
              ml: '20px',
              alignItems: 'center',
            }}
          >
            {categoryEditInputDatas.photoUrls.length < 3 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <input
                  accept="image/*"
                  id="input_img"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleAddImage}
                />
                <AddIcon sx={{ fontSize: '16px' }} />
                <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>
                  Add More
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* DIalog Photo */}
      {categoryEditInputDatas.linkPreviewPhoto !== 0 && (
        <Dialog
          open={categoryEditInputDatas.isPreviewPhoto}
          onClose={() => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              isPreviewPhoto: !categoryEditInputDatas.isPreviewPhoto,
            });
          }}
        >
          <Box
            component="img"
            src={
              process.env.REACT_APP_API_IMAGE_BASE_URL +
              '/' +
              categoryEditInputDatas.linkPreviewPhoto
            }
            sx={{ width: '100%', aspectRation: '1/1' }}
          />
        </Dialog>
      )}
      {/* description */}
      <Grid item xs={12}>
        <CustomInput
          sx={{
            width: '100%',
            bgcolor: '#FAFAFA',
            fontSize: '12px',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
          placeholder="Description"
          value={categoryEditInputDatas.description}
          onChange={(e) => {
            if (e.target.value.length <= 250) {
              setCategoryEditInputDatas({
                ...categoryEditInputDatas,
                description: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryEditInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid>
      {/* Schedule */}
      <Grid item xs={12} sx={{}}>
        <Box sx={{ display: 'flex', minWidth: '100%' }}>
          <DesktopDatePicker
            inputFormat="DD/MM/YYYY"
            value={categoryEditInputDatas.schedule}
            onChange={(newValue) => {
              if (categoryEditInputDatas.scheduleType !== 'now') {
                setCategoryEditInputDatas({
                  ...categoryEditInputDatas,
                  schedule: newValue,
                });
              } else {
                setCategoryEditInputDatas({
                  ...categoryEditInputDatas,
                  schedule: today,
                });
              }
            }}
            sx={{ fontSize: '12px' }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  width: '100%',
                  bgcolor: '#FAFAFA',
                  '.MuiOutlinedInput-input': {
                    fontSize: '12px',
                    padding: '12px',
                  },
                }}
              />
            )}
          />
        </Box>
      </Grid>
      {/* STATUS */}
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
          Publish
        </Typography>
        <AntSwitch
          checked={categoryEditInputDatas.publish}
          onChange={(e) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              publish: !categoryEditInputDatas.publish,
            });
          }}
        />
      </Grid>
      {/* SUBMIT */}
      <Grid
        item
        xs={12}
        sx={{ mt: '28px', display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <CustomButton
          // disabled={!isSubmitAvailable}
          onClick={handleDelete}
          variant="contained"
          sx={{
            width: '100%',
            bgcolor: theme.palette.error.main,
          }}
        >
          Delete
        </CustomButton>
        <CustomButton
          disabled={!isSubmitAvailable}
          onClick={handleEditCategory}
          variant="contained"
          sx={{
            width: '100%',
          }}
        >
          Edit
        </CustomButton>
      </Grid>
    </Grid>
  );
};
export default CategoryProductEditMobile;
